import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableAsyncSyncProductsAndSubmitAsn = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableAsyncSyncProductsAndSubmitAsn);
};
